export default "__VITE_ASSET__Bo0X2vPV__"